import type { ArenaStageConfig } from '../scenes/CombatArenaScene';

/** 지옥 I · 구역 1-1 안의 연속 단계(5구간). 예전 1-1~1-5 밸런스를 단계별로 편입. */
const WAVES_1_1: NonNullable<ArenaStageConfig['waves']> = [
  { killTarget: 26, enemySpawnMs: 1050, fireRateMs: 360, enemySpeed: 78 },
  { killTarget: 30, enemySpawnMs: 980, fireRateMs: 348, enemySpeed: 82 },
  { killTarget: 34, enemySpawnMs: 910, fireRateMs: 336, enemySpeed: 86 },
  { killTarget: 38, enemySpawnMs: 850, fireRateMs: 324, enemySpeed: 90 },
  { killTarget: 44, enemySpawnMs: 790, fireRateMs: 312, enemySpeed: 94 },
];

export function getHell1ArenaConfig(zoneId: string): ArenaStageConfig {
  if (zoneId !== '1-1') {
    return getHell1ArenaConfig('1-1');
  }

  return {
    killTarget: WAVES_1_1.reduce((a, w) => a + w.killTarget, 0),
    regionLabel: '지옥 I · 1-1 나선',
    playerColor: 0x7bc4e8,
    enemyColor: 0xa84444,
    projectileColor: 0xffcc66,
    cameraBgColor: '#1c1018',
    fireRateMs: WAVES_1_1[0].fireRateMs,
    enemySpawnMs: WAVES_1_1[0].enemySpawnMs,
    enemySpeed: WAVES_1_1[0].enemySpeed,
    clearTitle: '1-1 나선 정화',
    clearSubtitle: '거점으로 돌아갑니다…',
    nextSceneKey: 'HubScene',
    transitionDelayMs: 1800,
    playerMaxHp: 5,
    applyPersistentBonuses: true,
    hellStageId: '1-1',
    waves: WAVES_1_1,
  };
}
